import React from "react";
import { Trans } from "@lingui/macro";
import { PlusIcon } from "@heroicons/react/outline";
import { Button } from "components/UI/Button/Button";

export type typeDOrdersManagementActions = {
  onClickAdd: () => void;
  onClickExport: () => void;
};

export const DOrdersManagementActions: React.FC<
  typeDOrdersManagementActions
> = ({ onClickAdd, onClickExport }) => {
  return (
    <>
      <Button
        type="button"
        secondary={true}
        onClick={onClickAdd}
        label={<Trans>Add</Trans>}
        buttonClassName="flex-initial"
        icon={<PlusIcon className="w-5 h-5 mr-1" />}
      />
      <Button
        type="button"
        secondary={true}
        label={<Trans>Export</Trans>}
        buttonClassName="flex-initial"
        onClick={() => onClickExport()}
      />
    </>
  );
};
